module.exports = __webpack_public_path__ + "img/Padlock - Active.91a1d3cf.svg";